/**
 * Returns { isOpen: bool, label: string } based on the restaurant.business_hours map.
 * business_hours format: { mon: {open: "HH:MM", close: "HH:MM", closed?: bool}, tue: {...}, ... }
 * If `closed === true` → day is explicitly closed (new "Open" checkbox UX, 2026-06-09).
 * If open === close → treated as closed all day (legacy convention).
 * If close <= open → treated as open past midnight.
 */
export function getOpenStatus(businessHours) {
  if (!businessHours || typeof businessHours !== 'object') {
    return { isOpen: true, label: 'Open' }; // default optimistic if no hours configured
  }
  const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  const now = new Date();
  const today = days[now.getDay()];
  const hours = businessHours[today];
  if (!hours || hours.closed === true) return { isOpen: false, label: 'Closed today' };
  if (!hours.open || !hours.close) return { isOpen: false, label: 'Closed today' };

  const [oH, oM] = hours.open.split(':').map(Number);
  const [cH, cM] = hours.close.split(':').map(Number);
  if (oH === cH && oM === cM) return { isOpen: false, label: 'Closed today' };

  const nowMin = now.getHours() * 60 + now.getMinutes();
  const openMin = oH * 60 + oM;
  const closeMin = cH * 60 + cM;
  const crossesMidnight = closeMin <= openMin;
  const isOpen = crossesMidnight
    ? nowMin >= openMin || nowMin < closeMin
    : nowMin >= openMin && nowMin < closeMin;

  return {
    isOpen,
    label: isOpen ? `Open until ${hours.close}` : `Closed · opens ${hours.open}`,
  };
}
